import inView from 'in-view';

export const BodyController = ['$scope', 'compareTool', 'modalFactory', function($scope, $compare, $modal) {
    $scope.compare = $compare;
    $scope.openFavouritesModal = function() {
        $scope.compare.getFavoritedProperties()
        $modal.create($scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/favouritesModal.html');
    }
    inView.offset(100);
    inView('.js-InView')
        .on('enter', el => {
            el.classList.remove('anim-out')
            el.classList.add('anim-in')
        })
        .on('exit', el => {
            el.classList.remove('anim-in')
            el.classList.add('anim-out')
        })

}];